import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import KakobuySpreadsheetPage from "@/pages/kakobuy-spreadsheet/page";
import KakobuyFindsPage from "@/pages/kakobuy-finds/page";
import FAQPage from "@/pages/faq/page";
import GuidePage from "@/pages/guides/page";
import BlogPage from "@/pages/blog/page";
import BlogArticlePage from "@/pages/blog/article/page";
import BlogArticleStaticPage from "@/pages/blog/kakobuy-spreadsheet-kompletny-przewodnik/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet",
    element: <KakobuySpreadsheetPage />,
  },
  {
    path: "/kakobuy-finds",
    element: <KakobuyFindsPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/guides",
    element: <GuidePage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/kakobuy-spreadsheet-kompletny-przewodnik",
    element: <BlogArticleStaticPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;